<template>
  <div class="flex flex-row w-full mt-4">
    <template v-if="supersessionToEdit">
      <div class="flex-grow grid grid-cols-3 gap-4 p-0 h-full">
        <input
          type="text"
          class="regular clear full"
          placeholder="new supersession"
          v-model="supersessionToEdit.unificado"
          :disabled="!editing || loading"
        />
        <input
          type="text"
          class="regular clear full"
          placeholder="new supersession"
          v-model="supersessionToEdit.alternative"
          :disabled="!editing || loading"
        />
        <input
          type="text"
          class="regular clear full"
          placeholder="Extra info"
          v-model="supersessionToEdit.info"
          :disabled="!editing || loading"
        />
      </div>
      <div id="action" class="w-24 pl-4 flex justify-center items-center">
        <template v-if="!editing">
          <button @click="deleteSupersession()">
            <img class="base-icon" src="@/assets/icons/trash.svg" />
          </button>
          <button @click="editSupersession()" class="ml-2">
            <img class="base-icon" src="@/assets/icons/edit.svg" />
          </button>
        </template>
        <template v-else>
          <button @click="saveUpdate()">
            <img class="base-icon" src="@/assets/icons/save.svg" />
          </button>
          <button @click="discardUpdate()" class="ml-2">
            <img class="base-icon" src="@/assets/icons/remove-button.svg" />
          </button>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import { requestDeleteSupersession } from "@/api/store/SupersessionsService.js";
import { requestUpdateSupersession } from "@/api/masterAdmin/SupersessionsService.js";
export default {
  props: {
    supersession: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      editing: false,
      loading: false,
      supersessionToEdit: null
    };
  },
  mounted() {
    this.supersessionToEdit = { ...this.supersession };
  },
  methods: {
    deleteSupersession() {
      if (
        confirm(
          "Please confirm you wan to delete the supersession " +
            this.supersessionToEdit.ALTERNATIVE
        )
      ) {
        requestDeleteSupersession(this.supersessionToEdit.id).then(() => {
          this.$toast.open({
            message: "Supersession deleted",
            type: "success",
            position: "top-right"
          });
          this.$emit("deletedSupersession", this.supersessionToEdit.id);
        });
      }
    },
    editSupersession() {
      this.editing = true;
    },
    saveUpdate() {
      requestUpdateSupersession(
        this.supersessionToEdit.id,
        this.supersessionToEdit.info
      ).then(() => {
        this.$toast.open({
          message: "Supersession updated",
          type: "success",
          position: "top-right"
        });
        this.editing = false;
      });
    },
    discardUpdate() {
      this.supersessionToEdit = { ...this.supersession };
      this.editing = false;
    }
  }
};
</script>
